module.exports = __webpack_public_path__ + "static/media/elegirSucursal__auto.f72d5872.svg";